import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  isFirst: boolean;
  isLast: boolean;
  onPageChange: (page: number) => void;
  totalElements?: number;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  isFirst,
  isLast,
  onPageChange,
  totalElements
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between pt-4 border-t border-gray-100 mt-4">
      <p className="text-xs text-gray-500">
        Showing page {currentPage + 1} of {totalPages}
        {totalElements !== undefined && <span className="ml-1">({totalElements} total)</span>}
      </p>
      <div className="flex gap-2">
        <Button variant="secondary" size="sm" disabled={isFirst} onClick={() => onPageChange(currentPage - 1)} className="h-8 w-8 p-0">
          <ChevronLeft size={16} />
        </Button>
        <Button variant="secondary" size="sm" disabled={isLast} onClick={() => onPageChange(currentPage + 1)} className="h-8 w-8 p-0">
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
};